export default [
  {
    icon: 'mdi-close',
    title: 'Hapus Sekolah',
    event: 'onHapus',
    akses: 'psp-monev-dinas.delete',
  },
];
